import { TOAST_POSITIONS } from "@/providers/ToastProvider";
import { Toast } from "@/appComponents/Blocks/Cards/ToastContainer/Toast";

export const ToastContainer = ({ position = TOAST_POSITIONS.BOTTOM_LEFT, toasts, onRemove }) => {
  return (
    <div className={`toast-container toast-container--${position}`}>
      {toasts.map(toast => (
        <Toast key={toast.id} {...toast} onRemove={onRemove} />
      ))}
    </div>
  );
};
